var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"target"},[_c('SpinnerButton',_vm._b({staticClass:"tw-rounded-full",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},'SpinnerButton',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1),_c('div',{ref:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }